export default () => ({
  isAutomaticReconciliation: false,
  isLoading: false,
  error: null,
  clinicBankAccounts: [],
  clinicPaymentMethods: [],
  importedOFX: null,
  transactions: [],
  transactionsPage: 1,
  transactionsCount: 0,
  revisionsCount: 0,
  reconciledAutomaticallyCount: 0,
  matchedCount: 0,
  divergenceCount: 0,
  unmatchedCount: 0,
  finalizedCount: 0,
  archivedCount: 0,
  reconciliationStatFilter: null,
  /** Pareamentos locais da conciliação automática (sessão; persistido em localStorage). */
  reconciliationPairingUi: {
    matchedTransactions: [],
    foundByImportedId: {},
    enabledByImportedId: {}
  },
  archivedFromExtract: [],
  archivedEntriesFromApi: [],
  transactionsLimit: 0,
  transactionsLastPage: 0,
  sumToPay: 0,
  sumToReceive: 0,
  selectedTransactions: [],
  filters: {
    is_reconciled: 'pending',
    status_payment: null,
    description: null,
    period_status: 'payment_date',
    start: null,
    end: null,
    bank_account: null,
    payment_method: null,
    nsu: null,
    reconciled_by: null,
    beneficiary: null,
    patient: null,
    cost_center: null
  },
  ofxForm: {
    clinic_id: null,
    bank_account_id: null,
    /** Rótulo da conta (persistido na sessão) para exibir antes/durante carregar clinicBankAccounts. */
    bank_account_name: null,
    period: {
      start: null,
      end: null
    },
    period_status: 'payment_date',
    period_order: 'asc',
    file: null
  },
  newBillPrefillFromReconciliation: null
})
